import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Events, Classes } from '../global/constants';

gsap.registerPlugin(ScrollTrigger);

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	// ---------- Menu close on scroll down ----------

	const showAnim = gsap.from('.header-menu-fixed', {
		yPercent: -100,
		paused: true,
		duration: 0.2
	}).progress(1);

	ScrollTrigger.create({
		trigger: '.header-section',
		start: "top top",
		end: "99999",
		onUpdate: (self) => {
			self.direction === -1 ? showAnim.play() : showAnim.reverse()
		}
	});

	// ---------- Small Menu----------

	$('.header-menu-fixed').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: '#content-wrapper',
					start: '800px top',
					endTrigger: "footer",
					end: 'bottom top',
					// markers: true,
					scrub: true,
					toggleClass: {
						targets: 'body',
						className: "small-menu"
					},
				}
			});
		});
	});

	// ---------- Header (Star) ----------

	$('.header-section').each(function() {

		Animations.global.push(() => {

			const logo = document.querySelector('.star-icon .svg-star');

			if(logo) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						endTrigger: "footer",
						end: 'bottom top',
						invalidateOnRefresh: true,
						scrub: true,
					},
				});

				timeline.fromTo(logo, {
					rotate: 0,
					transformOrigin: '50% 50%',
				}, {
					rotate: window.innerHeight * 3,
					transformOrigin: '50% 50%',
					ease: 'none'
				});
			}
		});
	});

	// ---------- Parallax Images ----------

	$('.text-images-section, .two-images-section').each(function() {

		Animations.global.push(() => {

			const image = this.querySelector(':scope .image-column');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(image, {
					y: () => (this.classList.contains('two-images-section')) ? 0 : image.clientHeight - 100
				}, {
					y: () => (this.classList.contains('two-images-section')) ? 50 : 0
				});
			}
		});
	});

	$('.three-parallax-section').each(function() {

		Animations.global.push(() => {

			const image = this.querySelector(':scope .image-column');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,

						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(image, {
					y: () =>  image.clientHeight / 4
				}, {
					y: () => 0
				});
			}
		});
	});

	$('.instagram-section').each(function() {

		Animations.menu.min.push(() => {

			const image = this.querySelector(':scope .image-column:nth-of-type(3)');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,

						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(image, {
					y: () =>  0
				}, {
					y: () => -image.clientHeight / 4
				});
			}
		});

		Animations.menu.max.push(() => {

			const imagesOdd = this.querySelectorAll(':scope .image-column:nth-of-type(odd)');
			const imagesEven = this.querySelectorAll(':scope .image-column:nth-of-type(even)');

			imagesOdd.forEach(image => {

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,

							invalidateOnRefresh: true,
						},
					});

					timeline.fromTo(image, {
						y: () =>  image.clientHeight / 2
					}, {
						y: () => 0
					});
				}
			})

			imagesEven.forEach(image => {

				if(image) {

					const timeline = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,

							invalidateOnRefresh: true,
						},
					});

					timeline.fromTo(image, {
						y: () =>  0
					}, {
						y: () => image.clientHeight / 4
					});
				}
			})
		});
	});
};

$Elements.document.on(Events.page.enter, () => initScrollAnimations());
